import React from 'react';
import { Route, Routes as ReactRoutes, useLocation } from "react-router-dom";
import Dashboard from './Dashboard/Dashboard';
import ProductGrid from './Products/ProductGrid';
import ProductList from './Products/ProductList';
import ProductEdit from './Products/ProductEdit';
import ProductDetail from './Products/ProductDetail';
import ProductAdd from './Products/ProductAdd';
import ShoppingCart from './Products/ShoppingCart';
import Header from '../components/common/Header';
import CheckOut from './Products/CheckOut';
import CategoriesList from './Categories/CategoriesList';
import OrderList from './Orders/OrderList';
import OrderDetail from './Orders/OrderDetail';
import OrderInvoice from './Orders/OrderInvoice';
import CustomerList from './Customers/CustomerList';
import CustomerDetail from './Customers/CustomerDetail';
import CouponsList from './SalesPromotion.js/CouponsList';
import CouponsAdd from './SalesPromotion.js/CouponsAdd';
import CouponsEdit from './SalesPromotion.js/CouponsEdit';
import StockList from './Inventory/StockList';
import Purchase from './Inventory/Purchase';
import Supplier from './Inventory/Supplier';
import Return from './Inventory/Return';
import Departments from './Inventory/Departments';
import Invoices from './Accounts/Invoices';
import Expense from './Accounts/Expense';
import Salaryslip from './Accounts/Salaryslip';
import Chat from './App/Chat';
import ProfilePage from './Other Pages/ProfilePage'
import PricePlanExample from './Other Pages/PricePlanExample';
import ContactUs from './Other Pages/ContactUs';
import Icons from './Other Pages/Icon';
import FormsExample from './Other Pages/FormsExample';
import TableExample from './Other Pages/TableExample';
import ChartsExample from './Other Pages/ChartsExample';
import Alerts from './Uicomponent/Alerts';
import Badges from './Uicomponent/Badge';
import Breadcrumb from './Uicomponent/Breadcrumb';
import Buttons from './Uicomponent/Buttons';
import Cards from './Uicomponent/Card';
import Carousel from './Uicomponent/Carousel';
import Collapse from './Uicomponent/Collapse';
import Dropdowns from './Uicomponent/Dropdowns';
import ListGroup from './Uicomponent/ListGroup';
import ModalUI from './Uicomponent/Modal';
import NavbarUI from './Uicomponent/Navbar';
import NavsUI from './Uicomponent/Navs';
import PaginationUI from './Uicomponent/Pagination';
import PopoversUI from './Uicomponent/Popovers';
import ProgressUI from './Uicomponent/Progress';
import Scrollspy from './Uicomponent/Scrollspy';
import SpinnersUI from './Uicomponent/Spinners';
import ToastsUI from './Uicomponent/Toasts';
import Calendar from './App/Calendar';
import StaterPage from './Stater Page/StaterPage';
import Documentation from './Documentation/Documentation';
import Changelog from './Changelog/Changelog';
import CategoriesEdit from './Categories/CategoriesEdit';
import CategoriesAdd from './Categories/CategoriesAdd';
import StoreLocation from './StoreLocation/Storelocation';
import Help from './Help/Help';
import SimpleInvoice from '../components/Accounts/Invoice/SimpleInvoice';
import UsersList from "./Users/UsersList";
import UsersAdd from "./Users/UsersAdd";
import RolesList from "./Roles/RolesList";
import RolesAdd from "./Roles/RolesAdd";
import RolesEdit from "./Roles/RolesEdit";
import PermissionsList from "./Permissions/PermissionsList";
import PermissionsAdd from "./Permissions/PermissionsAdd";
import QrScan from "./QrScan";
import UsersEdit from "./Users/UsersEdit";
import WebUsersList from "./WebUsers/WebUsersList";
import WebUsersAdd from "./WebUsers/WebUsersAdd";
import WebUsersEdit from "./WebUsers/WebUsersEdit";
import BrandList from './Brands/BrandList';
import BrandAdd from './Brands/BrandAdd';
import BrandEdit from './Brands/BrandEdit';
import ModelList from './Models/ModelList';
import ModelAdd from './Models/ModelAdd';
import ModelEdit from './Models/ModelEdit';
import ColorsList from './Colors/ColorsList';
import ColorsAdd from './Colors/ColorsAdd';
import ColorsEdit from './Colors/ColorsEdit';
import ExitLocationsList from "./ExitLocations/ExitLocationsList";
import ExitLocationsAdd from "./ExitLocations/ExitLocationsAdd";
import ExitLocationsEdit from "./ExitLocations/ExitLocationsEdit";
import ValetPointsList from "./ExitLocations/ValetPointsList";
import ValetPointsAdd from "./ExitLocations/ValetPointsAdd";
import ValetPointsEdit from "./ExitLocations/ValetPointsEdit";
import DriversList from "./Drivers/DriversList";
import DriversAdd from "./Drivers/DriversAdd";
import DriversEdit from "./Drivers/DriversEdit";
import DriverIncidents from "./Drivers/DriverIncidents";
import IncidentsList from "./Incidents/IncidentsList";
import IncidentsAdd from "./Incidents/IncidentsAdd";
import IncidentsEdit from "./Incidents/IncidentsEdit";
import ChargesList from "./Charges/ChargesList";
import ChargesAdd from "./Charges/ChargesAdd";
import ChargesEdit from "./Charges/ChargesEdit";
import ReceiptSettingsList from './ReceiptSettings/ReceiptSettingsList';
import ReceiptSettingsAdd from './ReceiptSettings/ReceiptSettingsAdd';
import ReceiptSettingsEdit from './ReceiptSettings/ReceiptSettingsEdit';
import FeedbackList from './Feedback/FeedbackList';
import FeedbackAdd from './Feedback/FeedbackAdd';
import FeedbackEdit from './Feedback/FeedbackEdit';
import TicketSettingsList from './TicketSettings/TicketSettingsList';
import TicketSettingsAdd from './TicketSettings/TicketSettingsAdd';
import TicketSettingsEdit from './TicketSettings/TicketSettingsEdit';
import SMSSettingsList from './SMSSettings/SMSSettingsList';
import SMSSettingsAdd from './SMSSettings/SMSSettingsAdd';
import SMSSettingsEdit from './SMSSettings/SMSSettingsEdit';
import ReportsList from './Reports/ReportsList';
import ParkingAdd from './Parking/ParkingAdd';
import ParkingList from './Parking/ParkingList';
import ParkingEdit from './Parking/ParkingEdit';
import ParkingView from './Parking/ParkingView';
import Footer from '../components/common/Footer';
import ParkingCustomerTicket from './Parking/ParkingCustomerTicket';
import ParkingCarTicket from './Parking/ParkingCarTicket';
import ParkingKeyTicket from './Parking/ParkingKeyTicket';
import ParkingCombinedTicket from './Parking/ParkingCombinedTicket';
import ParkingValetTicket from './Parking/ParkingValetTicket';
import ParkingPrintOptions from './Parking/ParkingPrintOptions';
import ParkingQRCode from './Parking/ParkingQRCode';
import EnquiriesList from './Enquiries/EnquiriesList';
import EnquiryDetail from './Enquiries/EnquiryDetail';
import ImportTicketsList from './ImportTickets/ImportTicketsList';
import AttendanceScreen from './attendance/AttendanceScreen';
import AttendanceHistoryScreen from './attendance/AttendanceHistoryScreen';

function MainIndex (props) {
    const { activekey } = props;
    const location = useLocation();
    const isPrintRoute = location.pathname.includes('parking-customer-ticket') || 
                        location.pathname.includes('parking-car-ticket') ||
                        location.pathname.includes('parking-key-ticket') ||
                        location.pathname.includes('parking-qr-code');    
    return (
      <div className='main px-lg-4 px-md-4' >
        {(!isPrintRoute || activekey === "/chat") && <Header />}
        <div className="body d-flex py-3 ">
        <ReactRoutes>


            {/*<Route exact path={process.env.PUBLIC_URL + '/permissions-list'} element={<PermissionsList />} />
            <Route exact path={process.env.PUBLIC_URL + '/permissions-add'} element={<PermissionsAdd />} */}

            <Route exact path={process.env.PUBLIC_URL + '/qr-scan'} element={<QrScan />} />

            <Route exact path={process.env.PUBLIC_URL + '/accounts/exit-locations-list'} element={<ExitLocationsList />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/exit-locations-add'} element={<ExitLocationsAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/exit-locations-edit/:id'} element={<ExitLocationsEdit />} />

            <Route exact path={process.env.PUBLIC_URL + '/accounts/valet-points-list'} element={<ValetPointsList />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/valet-points-add'} element={<ValetPointsAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/valet-points-edit/:id'} element={<ValetPointsEdit />} />

            <Route exact path={process.env.PUBLIC_URL + '/accounts/roles-list'} element={<RolesList />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/roles-add'} element={<RolesAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/roles-edit/:id'} element={<RolesEdit/>} />

            <Route exact path={process.env.PUBLIC_URL + '/accounts/users-list'} element={<UsersList />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/users-add'} element={<UsersAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/users-edit/:id'} element={<UsersEdit />} />

            <Route exact path={process.env.PUBLIC_URL + '/web-users-list'} element={<WebUsersList />} />
            <Route exact path={process.env.PUBLIC_URL + '/web-users-add'} element={<WebUsersAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/web-users-edit/:id'} element={<WebUsersEdit />} />

            <Route exact path={process.env.PUBLIC_URL + '/accounts/brands-list'} element={<BrandList />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/brands-add'} element={<BrandAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/brands-edit/:id'} element={<BrandEdit />} />

            <Route exact path={process.env.PUBLIC_URL + '/accounts/models-list'} element={<ModelList />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/models-add'} element={<ModelAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/models-edit/:id'} element={<ModelEdit />} />

            <Route exact path={process.env.PUBLIC_URL + '/accounts/colors-list'} element={<ColorsList />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/colors-add'} element={<ColorsAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/colors-edit/:id'} element={<ColorsEdit />} />

            <Route exact path={process.env.PUBLIC_URL + '/accounts/drivers-list'} element={<DriversList />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/drivers-add'} element={<DriversAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/drivers-edit/:id'} element={<DriversEdit />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/driver-incidents/:id'} element={<DriverIncidents />} />

            <Route exact path={process.env.PUBLIC_URL + '/accounts/incidents-list'} element={<IncidentsList />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/incidents-add'} element={<IncidentsAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/incidents-edit/:id'} element={<IncidentsEdit />} />

            <Route exact path={process.env.PUBLIC_URL + '/accounts/charges-list'} element={<ChargesList />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/charges-add'} element={<ChargesAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/charges-edit/:id'} element={<ChargesEdit />} />
            
            <Route exact path={process.env.PUBLIC_URL + '/accounts/receipt-settings-list'} element={<ReceiptSettingsList />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/receipt-settings/add'} element={<ReceiptSettingsAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/receipt-settings/edit/:id'} element={<ReceiptSettingsEdit />} />

            <Route exact path={process.env.PUBLIC_URL + '/accounts/feedback-list'} element={<FeedbackList />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/feedback-add'} element={<FeedbackAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/feedback-edit/:id'} element={<FeedbackEdit />} />

            <Route exact path={process.env.PUBLIC_URL + '/accounts/ticket-settings-list'} element={<TicketSettingsList />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/ticket-settings/add'} element={<TicketSettingsAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/ticket-settings/edit/:id'} element={<TicketSettingsEdit />} />

            <Route exact path={process.env.PUBLIC_URL + '/accounts/sms-settings-list'} element={<SMSSettingsList />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/sms-settings/add'} element={<SMSSettingsAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/sms-settings/edit/:id'} element={<SMSSettingsEdit />} />
            
            <Route exact path={process.env.PUBLIC_URL + '/accounts/import-tickets'} element={<ImportTicketsList />} />

            <Route exact path={process.env.PUBLIC_URL + '/accounts/attendance'} element={<AttendanceScreen />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/attendance/history/:driverId'} element={<AttendanceHistoryScreen />} />

            <Route exact path={process.env.PUBLIC_URL + '/accounts/reports'} element={<ReportsList />} />

            <Route exact path={process.env.PUBLIC_URL + '/accounts/parking/add'} element={<ParkingAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/parking-list'} element={<ParkingList />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/parking/edit/:id'} element={<ParkingEdit />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/parking/view/:id'} element={<ParkingView />} />
            <Route exact path={process.env.PUBLIC_URL + '/accounts/parking-print-options/:id'} element={<ParkingPrintOptions />} />
            <Route 
              exact 
              path={process.env.PUBLIC_URL + '/accounts/parking-customer-ticket/:id'} 
              element={<ParkingCustomerTicket />} 
            />
            <Route 
              exact 
              path={process.env.PUBLIC_URL + '/accounts/parking-qr-code/:id'} 
              element={<ParkingQRCode />} 
            />
            <Route 
              exact 
              path={process.env.PUBLIC_URL + '/accounts/parking-car-ticket/:id'} 
              element={
                <div className="print-only">
                  <ParkingCarTicket />
                </div>
              } 
            />
            <Route 
              exact 
              path={process.env.PUBLIC_URL + '/accounts/parking-key-ticket/:id'} 
              element={
                <div className="print-only">
                  <ParkingKeyTicket />
                </div>
              } 
            />
            <Route 
              exact 
              path={process.env.PUBLIC_URL + '/accounts/parking-combined-ticket/:id'} 
              element={
                <div className="print-only">
                  <ParkingCombinedTicket />
                </div>
              } 
            />
            <Route 
              exact 
              path={process.env.PUBLIC_URL + '/accounts/parking-valet-ticket/:id'} 
              element={
                <div className="print-only">
                  <ParkingValetTicket />
                </div>
              } 
            />

            <Route path="/accounts/enquiries" element={<EnquiriesList />} />
            <Route path="/accounts/enquiries/:id" element={<EnquiryDetail />} />

            {/*<Route exact path={process.env.PUBLIC_URL + "/"} element={<Dashboard />} />*/}
            <Route exact path={process.env.PUBLIC_URL + "/accounts/dashboard"} element={<Dashboard />} />
            <Route exact path={process.env.PUBLIC_URL + '/product-grid'} element={<ProductGrid />} />
            <Route exact path={process.env.PUBLIC_URL + '/product-list'} element={<ProductList />} />
            <Route exact path={process.env.PUBLIC_URL + '/product-edit'} element={<ProductEdit />} />
            <Route exact path={process.env.PUBLIC_URL + '/product-detail'} element={<ProductDetail />} />
            <Route exact path={process.env.PUBLIC_URL + '/product-Add'} element={<ProductAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/shopping-cart'} element={<ShoppingCart />} />
            <Route exact path={process.env.PUBLIC_URL + '/check-out'} element={<CheckOut />} />
            <Route exact path={process.env.PUBLIC_URL + '/categories-edit'} element={<CategoriesEdit />} />
            <Route exact path={process.env.PUBLIC_URL + '/categories-add'} element={<CategoriesAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/order-list'} element={<OrderList />} />
            <Route exact path={process.env.PUBLIC_URL + '/order-detail'} element={<OrderDetail />} />
            <Route exact path={process.env.PUBLIC_URL + '/order-invoice'} element={<OrderInvoice />} />
            <Route exact path={process.env.PUBLIC_URL + '/customer-list'} element={<CustomerList />} />
            <Route exact path={process.env.PUBLIC_URL + '/customer-detail'} element={<CustomerDetail />} />
            <Route exact path={process.env.PUBLIC_URL + '/coupons-list'} element={<CouponsList />} />
            <Route exact path={process.env.PUBLIC_URL + '/coupons-add'} element={<CouponsAdd />} />
            <Route exact path={process.env.PUBLIC_URL + '/coupons-edit'} element={<CouponsEdit />} />
            <Route exact path={process.env.PUBLIC_URL + '/stock-list'} element={<StockList />} />
            <Route exact path={process.env.PUBLIC_URL + '/purchase'} element={<Purchase />} />
            <Route exact path={process.env.PUBLIC_URL + '/supplier'} element={<Supplier />} />
            <Route exact path={process.env.PUBLIC_URL + '/return'} element={<Return />} />
            <Route exact path={process.env.PUBLIC_URL + '/departments'} element={<Departments />} />
            <Route exact path={process.env.PUBLIC_URL + '/invoices'} element={<Invoices />} />
            <Route exact path={process.env.PUBLIC_URL + '/simple-invoice'} element={<SimpleInvoice />} />

            <Route exact path={process.env.PUBLIC_URL + '/expense'} element={<Expense />} />
            <Route exact path={process.env.PUBLIC_URL + '/salaryslip'} element={<Salaryslip />} />
            <Route exact path={process.env.PUBLIC_URL + '/chat'} element={<Chat />} />
            <Route exact path={process.env.PUBLIC_URL + '/calendar'} element={<Calendar />} />
            <Route exact path={process.env.PUBLIC_URL + '/store-location'} element={<StoreLocation />} />

            <Route exact path={process.env.PUBLIC_URL + '/profile-pages'} element={<ProfilePage />} />
            <Route exact path={process.env.PUBLIC_URL + '/price-plan'} element={<PricePlanExample />} />
            <Route exact path={process.env.PUBLIC_URL + '/contact-us'} element={<ContactUs />} />
            <Route exact path={process.env.PUBLIC_URL + '/icons'} element={<Icons />} />
            <Route exact path={process.env.PUBLIC_URL + '/form-example'} element={<FormsExample />} />
            <Route exact path={process.env.PUBLIC_URL + '/table-example'} element={<TableExample />} />
            <Route exact path={process.env.PUBLIC_URL + '/charts-example'} element={<ChartsExample />} />

            <Route exact path={process.env.PUBLIC_URL + '/ui-alerts'} element={<Alerts />} />
            <Route exact path={process.env.PUBLIC_URL + '/ui-badge'} element={<Badges />} />
            <Route exact path={process.env.PUBLIC_URL + '/ui-breadcrumb'} element={<Breadcrumb />} />
            <Route exact path={process.env.PUBLIC_URL + '/ui-buttons'} element={<Buttons />} />
            <Route exact path={process.env.PUBLIC_URL + '/ui-card'} element={<Cards />} />
            <Route exact path={process.env.PUBLIC_URL + '/ui-carousel'} element={<Carousel />} />
            <Route exact path={process.env.PUBLIC_URL + '/ui-collapse'} element={<Collapse />} />
            <Route exact path={process.env.PUBLIC_URL + '/ui-dropdowns'} element={<Dropdowns />} />
            <Route exact path={process.env.PUBLIC_URL + '/ui-listgroup'} element={<ListGroup />} />
            <Route exact path={process.env.PUBLIC_URL + '/ui-modalui'} element={<ModalUI />} />
            <Route exact path={process.env.PUBLIC_URL + '/ui-navbarui'} element={<NavbarUI />} />
            <Route exact path={process.env.PUBLIC_URL + '/ui-navsui'} element={<NavsUI />} />
            <Route exact path={process.env.PUBLIC_URL + '/ui-paginationui'} element={<PaginationUI />} />
            <Route exact path={process.env.PUBLIC_URL + '/ui-popoversui'} element={<PopoversUI />} />
            <Route exact path={process.env.PUBLIC_URL + '/ui-progressui'} element={<ProgressUI />} />
            <Route exact path={process.env.PUBLIC_URL + '/ui-Scrollspyui'} element={<Scrollspy />} />
            <Route exact path={process.env.PUBLIC_URL + '/ui-spinnersui'} element={<SpinnersUI />} />
            <Route exact path={process.env.PUBLIC_URL + '/ui-toastsui'} element={<ToastsUI />} />
            <Route exact path={process.env.PUBLIC_URL + '/stater-page'} element={<StaterPage />} />
            <Route exact path={process.env.PUBLIC_URL + '/documentation'} element={<Documentation />} />
            <Route exact path={process.env.PUBLIC_URL + '/changelog'} element={<Changelog />} />

            <Route exact path={process.env.PUBLIC_URL + '/help'} element={<Help />} />

          </ReactRoutes>
        </div>
        {!isPrintRoute && <Footer />}
      </div>
    );
  }
export default MainIndex;